import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { ChevronRight } from "lucide-react";
import { BookingApi } from "../../api/services";
import { EmptyState, PageHeader, Spinner, StatusBadge } from "../../components/common";
import { dateTime, peso } from "../../lib/format";

const ACTIVE = ["requested", "assigned", "accepted", "en_route", "at_pickup", "in_transit"];

function Row({ b }: { b: any }) {
  return (
    <Link to={`/patient/bookings/${b.id}`} className="fp-card flex items-center justify-between gap-3 hover:border-[#036248]" data-testid="booking-row">
      <div className="min-w-0">
        <p className="fp-label">{b.type} · {b.code}</p>
        <p className="mt-1 truncate font-medium text-slate-900">{b.pickup.address || "Pinned location"}{b.destination ? ` → ${b.destination.address || "destination"}` : ""}</p>
        <p className="text-xs text-slate-500">{dateTime(b.scheduled_at || b.created_at)} · {peso(b.fare_estimate)} · {b.payment_status}</p>
      </div>
      <div className="flex shrink-0 items-center gap-2"><StatusBadge status={b.status} /><ChevronRight size={16} /></div>
    </Link>
  );
}

export default function Bookings() {
  const { data, isLoading } = useQuery({ queryKey: ["bookings"], queryFn: BookingApi.mine });
  if (isLoading) return <Spinner />;
  const active = (data || []).filter((b) => ACTIVE.includes(b.status));
  const past = (data || []).filter((b) => !ACTIVE.includes(b.status));
  return (
    <div className="space-y-6">
      <PageHeader title="My trips" />
      <section className="space-y-2" data-testid="active-bookings">
        <h2 className="fp-label">Active</h2>
        {active.length ? active.map((b) => <Row key={b.id} b={b} />) : <EmptyState title="No active trips" />}
      </section>
      <section className="space-y-2" data-testid="booking-history">
        <h2 className="fp-label">History</h2>
        {past.length ? past.map((b) => <Row key={b.id} b={b} />) : <EmptyState title="No past trips yet" />}
      </section>
    </div>
  );
}
